import React from 'react';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { JobManagerChainSelector } from '../job-manager-chain-selector/JobManagerChainSelector';
import { validationsMessages } from 'lib';
import {
    TruncateOrDropChainSelectFieldProps,
    truncateOrDropChainSelectFieldStyles,
} from './truncate-or-drop-chain-select-field-helper';

export const TruncateOrDropChainSelectField = ({
    control,
    errors,
    containerStyles,
}: TruncateOrDropChainSelectFieldProps): React.JSX.Element => {
    return (
        <Grid
            sx={{
                ...truncateOrDropChainSelectFieldStyles.truncateOrDropContainer,
                ...containerStyles,
            }}
        >
            <Grid
                sx={
                    truncateOrDropChainSelectFieldStyles.truncateOrDropJobContainerWidth
                }
            >
                <Controller
                    name='chain'
                    control={control}
                    render={({ field }): React.JSX.Element => (
                        <JobManagerChainSelector
                            onChange={(__, value): void => {
                                field.onChange(value);
                            }}
                            required={true}
                            error={!!errors.chain}
                            errorText={
                                errors.chain ? validationsMessages.required : ''
                            }
                        />
                    )}
                />
            </Grid>
        </Grid>
    );
};
